import request from "../../../utils/wapRequest";

const url = process.env.VUE_APP_WAP_API;
export function loginShopSTB(data) {
  return request({
    url: `${url}/login_shop_STB`,
    method: "post",
    // params: data,
    data
  });
}

export function loginHioSTB(data) {
  return request({
    url: `${url}/login_hio_STB`,
    method: "post",
    // params: data,
    data
  });
}

export function loginHandde(data) {
  return request({
    url: `${url}/create_token_handde`,
    method: "post",
    // params: data,
    data
  });
}
